import type { ValidationErrors } from '../../../../../utils/validation';
import type { ICustomControlData } from './customControlData';
import { FormContextProvider } from '../../../../elements/formContext';
import { TextAreaField } from '../../../../fields/TextArea';
import { BloeddrukAddEdit } from '../../TCOR/v1/BloeddrukAddEdit';
import { BmiAddEdit } from '../../utils/v1/BmiAddEdit';
import { AdviesBijAfwijkendeBeoordelingAddEdit } from './AdviesBijAfwijkendeBeoordelingAddEdit';
import { GeslachtAddEdit } from './GeslachtAddEdit';
import { IndicatieAddEdit } from './IndicatieAddEdit';
import { MedicatieAddEdit } from './MedicatieAddEdit';
import { OpnameduurAddEdit } from './OpnameduurAddEdit';
import { PacemakerAddEdit } from './PacemakerAddEdit';
import { ProcedureTypeAddEdit } from './ProcedureTypeAddEdit';

type TcohV2RequestAddEditCustomControlFieldsProps = {
    customControlData: ICustomControlData;
    errors: ValidationErrors;
    handleChangeCustomControl: (customControl: Partial<ICustomControlData>) => Promise<void>;
    validateOneCustomControl: (name: string) => Promise<void>;
};

export function TcohV2RequestAddEditCustomControlFields(props: TcohV2RequestAddEditCustomControlFieldsProps) {
    return (
        <FormContextProvider
            value={{
                errors: props.errors,
                item: props.customControlData,
                onChange: async (key, value) => await props.handleChangeCustomControl({ [key]: value }),
                onDoValidate: async (key) => await props.validateOneCustomControl(key),
                placeholderGroupName: 'request',
            }}
        >
            <GeslachtAddEdit {...props} />
            <ProcedureTypeAddEdit {...props} />
            <OpnameduurAddEdit
                customControlData={props.customControlData}
                errors={props.errors}
                onChange={async (key, value) => await props.handleChangeCustomControl({ [key]: value })}
                onDoValidate={async (key) => await props.validateOneCustomControl(key)}
            />
            <PacemakerAddEdit {...props} />
            <IndicatieAddEdit
                {...props}
                isRequired
            />
            <MedicatieAddEdit {...props} />
            <BloeddrukAddEdit
                customControlData={{
                    bloeddruk_diastolisch: props.customControlData.bloeddruk_diastolisch || null,
                    bloeddruk_systolisch: props.customControlData.bloeddruk_systolisch || null,
                }}
                errors={props.errors}
                handleChange={async (values) => await props.handleChangeCustomControl(values)}
                validateOne={async (name) => await props.validateOneCustomControl(name)}
            />
            <BmiAddEdit {...props} />

            <TextAreaField
                error={props.errors.get('customControlData.toelichting')}
                fieldKey="toelichting"
                hasErrors={props.errors.has('customControlData.toelichting')}
                label="Toelichting"
                placeholder="Een toelichting, opmerkingen of vragen..."
                value={props.customControlData.toelichting || null}
            />

            <AdviesBijAfwijkendeBeoordelingAddEdit {...props} />
        </FormContextProvider>
    );
}
